import { render } from "./CustomerNavigation.vue?vue&type=template&id=2e00da08&scoped=true"
import script from "./CustomerNavigation.vue?vue&type=script&lang=js"
export * from "./CustomerNavigation.vue?vue&type=script&lang=js"

import "./CustomerNavigation.vue?vue&type=style&index=0&id=2e00da08&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e00da08"]])

export default __exports__